import React from 'react'

import {
  Button,
  Well,
  WellLabel,
  LinkBoxWrapper,
  LinkBox,
} from '../../styles'

const GameLink = ({link, buttonText}) => (
  <Well>
    <WellLabel>Invite link</WellLabel>
    <LinkBoxWrapper>
      <LinkBox href={link}>{link}</LinkBox>
    </LinkBoxWrapper>
    <Button id="copy-link-button" data-clipboard-text={link}>{buttonText}</Button>
  </Well>
)

export default GameLink



// WEBPACK FOOTER //
// ./src/views/game/components/GameLink.jsx